export function get_url( hash: string, size = 500 ) {
    if ( !hash ) throw new Error("hash is required");
    return `https://functions.eosn.io/v2/ipfs/${hash}?size=${size}`
}

export function get_fallback_url( hash: string, size = 500 ) {
    if ( !hash ) throw new Error("hash is required");
    return `https://cloudflare-ipfs.com/ipfs/${hash}`
}
